import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { Button } from "aible";

import * as viewReducer from "containers/View/reducer";
import * as globalReducer from "containers/App/reducer";
import * as recipeReducer from "containers/Recipe/reducer";

import RecipeItem from "containers/View/Item/RecipeItem";

import SubView from "components/View/SubView";

import RecipeTile from "components/Tiles/RecipeTile";

import TraySolutionViewContainer from "containers/View/TraySolution";

import CreateRecipeModal from "components/Recipe/CreateRecipeModal";
import EmptyTile from "components/Tiles/EmptyTile";

class RecipeViewContainer extends React.PureComponent {
  handleCreateRecipe(solution) {
    const { setCreateRecipeModalIsOpen, createRecipeFromSolution, allowRecipeCreation } = this.props;

    if (allowRecipeCreation) {
      createRecipeFromSolution(solution.id).then(() => setCreateRecipeModalIsOpen(false));
    }
  }

  renderFirstTile() {
    const { hideFirst, setCreateRecipeModalIsOpen } = this.props;

    if (hideFirst) {
      return <EmptyTile />;
    }

    return (
      <div>
        <RecipeTile onClick={() => setCreateRecipeModalIsOpen(true)} isCreate />
      </div>
    );
  }

  renderFirstRow() {
    const { hideFirst, onClick, setCreateRecipeModalIsOpen } = this.props;

    if (hideFirst) {
      return <EmptyTile />;
    }

    return (
      <div>
        <Button type="secondary" onClick={() => setCreateRecipeModalIsOpen(true)}>
          {"Create New Recipe"}
        </Button>
      </div>
    );
  }

  getHeaders() {
    return ["Recipe", "Creation"];
  }

  renderTile(index, style) {
    const { recipeIds, onClick } = this.props;

    if (index >= recipeIds.length) {
      return undefined;
    }

    const id = recipeIds[index];

    return <RecipeItem id={id} onClick={onClick} key={index} style={style} />;
  }

  render() {
    const {
      recipeIds,
      type,
      isTile,
      isLoading,
      fetchNext,
      fetchAll,
      createRecipeModalIsOpen,
      setCreateRecipeModalIsOpen
    } = this.props;

    return (
      <React.Fragment>
        <SubView
          type={type}
          isTile={isTile}
          isLoading={isLoading}
          fetchNext={fetchNext}
          fetchAll={fetchAll}
          label="Recipes"
          headers={this.getHeaders()}
          firstTile={this.renderFirstTile()}
          firstRow={this.renderFirstRow()}
          length={recipeIds.length}
          isInfinite={true}
          renderTile={this.renderTile.bind(this)}
          childrenLength={recipeIds.length}
        />
        <CreateRecipeModal
          isOpen={createRecipeModalIsOpen}
          onClose={() => setCreateRecipeModalIsOpen(false)}
          title="Select a Recipe"
        >
          {createRecipeModalIsOpen && <TraySolutionViewContainer onClick={(id) => this.handleCreateRecipe(id)} />}
        </CreateRecipeModal>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchNext: () => dispatch(recipeReducer.fetchRecipes()),
  fetchAll: () => dispatch(recipeReducer.fetchRecipes()),
  setCreateRecipeModalIsOpen: (isOpen) => dispatch(recipeReducer.setCreateRecipeModalIsOpen(isOpen)),
  createRecipeFromSolution: (solutionId) => dispatch(recipeReducer.createRecipeFromSolution(solutionId))
});

const mapStateToProps = (state, ownProps) => ({
  recipeIds: ownProps.solutionType
    ? recipeReducer.getRecipeIdsBySolutionType(state, ownProps.solutionType)
    : recipeReducer.getRecipeIds(state),
  type: ownProps.type || viewReducer.getType(state),
  isTile: viewReducer.getIsTile(state),
  isLoading: globalReducer.getIsRecipesLoading(state),
  createRecipeModalIsOpen: recipeReducer.getCreateRecipeModalIsOpen(state),
  allowRecipeCreation: recipeReducer.areNoRecipesBeingCreated(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RecipeViewContainer);
